import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getPartnerCartPreorderOptions from '@nike/shop-apis/buy/partner_cart_preorder/v2/get-options';
import getPaypalExpressOptions from '@nike/shop-apis/payment/paypal_express/v2/get-options';
import getFetchCartReviewsOptions from '@nike/shop-apis/buy/cart_reviews/v2/fetch/get-options';
import getFetchCartOptions from '@nike/shop-apis/buy/carts/v2/fetch/get-options';
import getFetchGlobalConfigOptions from '@nike/shop-apis/global-config/get-options';
import getWebShellClientLocale from '@nike/shop-apis/utils/get-webshellclient-locale';
import getCheckoutHref from '@nike/shop-apis/utils/get-checkout-href';
var trackAndNavigate = function trackAndNavigate(_ref) {
  var url = _ref.url,
    telemetryData = _ref.telemetryData;
  window.newrelic.addPageAction('nike-shop-checkout-intent-start-poc', telemetryData);
  window.location.assign(url);
};
var navigateToCheckout = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var _ref2$isPayPal, paypalClicked, _ref2$redirectToCheck, redirectToCheckout, queryClient, isLoggedIn, _yield$queryClient$fe, isGlobalStoreCountry, _getWebShellClientLoc, country, checkoutType, _partnerCartPreorderD, partnerCartPreorderData, redirectUrl, _cartReviewsData$resp, _cartReviewsData$resp2, _paypalExpressData$re, _yield$Promise$all, _yield$Promise$all2, _yield$Promise$all2$, cartItems, cartReviewsData, totals, cartReviewsItems, mergedItems, paypalExpressData, _redirectUrl;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2$isPayPal = _ref2.isPayPal, paypalClicked = _ref2$isPayPal === void 0 ? false : _ref2$isPayPal, _ref2$redirectToCheck = _ref2.redirectToCheckout, redirectToCheckout = _ref2$redirectToCheck === void 0 ? false : _ref2$redirectToCheck, queryClient = _ref2.queryClient;
          _context.next = 1;
          return window.webShellClient.identity.getIsLoggedIn();
        case 1:
          isLoggedIn = _context.sent;
          _context.next = 2;
          return queryClient.fetchQuery(getFetchGlobalConfigOptions());
        case 2:
          _yield$queryClient$fe = _context.sent;
          isGlobalStoreCountry = _yield$queryClient$fe.isGlobalStoreCountry;
          _getWebShellClientLoc = getWebShellClientLocale(), country = _getWebShellClientLoc.country;
          checkoutType = isLoggedIn ? 'registered' : 'guest';
          if (!isGlobalStoreCountry) {
            _context.next = 4;
            break;
          }
          checkoutType = paypalClicked ? 'paypal' : checkoutType;
          _context.next = 3;
          return queryClient.fetchQuery(getPartnerCartPreorderOptions({
            paypalClicked: paypalClicked,
            queryClient: queryClient
          }));
        case 3:
          partnerCartPreorderData = _context.sent;
          redirectUrl = partnerCartPreorderData === null || partnerCartPreorderData === void 0 || (_partnerCartPreorderD = partnerCartPreorderData.response) === null || _partnerCartPreorderD === void 0 ? void 0 : _partnerCartPreorderD.redirectUrl;
          if (redirectUrl) {
            trackAndNavigate({
              url: redirectUrl,
              telemetryData: {
                checkoutType: checkoutType,
                paypalClicked: paypalClicked,
                country: country
              }
            });
          } else {
            window.newrelic.addPageAction('nike-shop-partnercart-failure', {
              code: 'PARTNERCART_SUCCESS_NO_URL',
              message: 'No redirectUrl in successful response.'
            });
          }
          window.newrelic.addPageAction('nike-shop-partnercart-failure', {
            code: 'PARTNERCART_ERROR',
            message: 'No redirectUrl in successful response.'
          });
          return _context.abrupt("return");
        case 4:
          if (!paypalClicked) {
            _context.next = 8;
            break;
          }
          checkoutType = 'paypal';

          // Execute both fetch queries in parallel
          _context.next = 5;
          return Promise.all([queryClient.fetchQuery(getFetchCartOptions({
            queryClient: queryClient
          })), queryClient.fetchQuery(getFetchCartReviewsOptions({
            appName: 'CiCCart',
            queryClient: queryClient
          }))]);
        case 5:
          _yield$Promise$all = _context.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          _yield$Promise$all2$ = _yield$Promise$all2[0].items;
          cartItems = _yield$Promise$all2$ === void 0 ? [] : _yield$Promise$all2$;
          cartReviewsData = _yield$Promise$all2[1];
          totals = cartReviewsData === null || cartReviewsData === void 0 || (_cartReviewsData$resp = cartReviewsData.response) === null || _cartReviewsData$resp === void 0 ? void 0 : _cartReviewsData$resp.totals;
          cartReviewsItems = (cartReviewsData === null || cartReviewsData === void 0 || (_cartReviewsData$resp2 = cartReviewsData.response) === null || _cartReviewsData$resp2 === void 0 || (_cartReviewsData$resp2 = _cartReviewsData$resp2.fulfillmentGroups) === null || _cartReviewsData$resp2 === void 0 || (_cartReviewsData$resp2 = _cartReviewsData$resp2[0]) === null || _cartReviewsData$resp2 === void 0 ? void 0 : _cartReviewsData$resp2.items) || []; // carts and cart reviews have the same sort order, so can safely lookup with current index since they match
          mergedItems = cartItems.map(function (item, idx) {
            var _cartReviewsItems$idx;
            return _objectSpread(_objectSpread({}, item), {}, {
              itemCosts: {
                priceInfo: _objectSpread(_objectSpread({}, item.priceInfo), ((_cartReviewsItems$idx = cartReviewsItems[idx]) === null || _cartReviewsItems$idx === void 0 ? void 0 : _cartReviewsItems$idx.itemCosts.priceInfo) || {})
              }
            });
          });
          _context.next = 6;
          return queryClient.fetchQuery(getPaypalExpressOptions({
            queryClient: queryClient,
            totals: totals,
            items: mergedItems
          }));
        case 6:
          paypalExpressData = _context.sent;
          _redirectUrl = (paypalExpressData === null || paypalExpressData === void 0 || (_paypalExpressData$re = paypalExpressData.response) === null || _paypalExpressData$re === void 0 ? void 0 : _paypalExpressData$re.redirectURL) || '';
          if (!_redirectUrl) {
            _context.next = 7;
            break;
          }
          trackAndNavigate({
            url: _redirectUrl,
            telemetryData: {
              checkoutType: checkoutType,
              paypalClicked: paypalClicked,
              country: country
            }
          });
          return _context.abrupt("return");
        case 7:
          _context.next = 9;
          break;
        case 8:
          if (!redirectToCheckout) {
            _context.next = 9;
            break;
          }
          trackAndNavigate({
            url: getCheckoutHref({
              queryClient: queryClient,
              isLoggedIn: isLoggedIn
            }),
            telemetryData: {
              checkoutType: checkoutType,
              paypalClicked: paypalClicked,
              country: country
            }
          });
          return _context.abrupt("return");
        case 9:
          // We should not reach this point if we have there was a misuse of this action
          window.newrelic.addPageAction('nike-shop-checkout-condition-failure', {
            checkoutType: checkoutType,
            paypalClicked: paypalClicked,
            country: country
          });
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function navigateToCheckout(_x) {
    return _ref3.apply(this, arguments);
  };
}();
export default navigateToCheckout;